// extracted by mini-css-extract-plugin
export default {"rank":"Rank_rank__OuIJR"};